import { Box, Typography, Chip } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { MedicalActTemplate } from '@/core/models/medical-act.model'
import { formatPrice } from '@/utils/formatPrice'

export type SelectedTemplateInfoProps = {
    template: MedicalActTemplate
}

export function SelectedTemplateInfo({ template }: SelectedTemplateInfoProps) {
    const { t } = useTranslation()

    return (
        <Box sx={{ p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
            <Typography variant="subtitle2" color="text.secondary">
                {t('medicalAct.record.selectedAct', { defaultValue: 'Selected Act' })}
            </Typography>
            <Typography variant="h6">{template.name}</Typography>
            {template.description && (
                <Typography variant="body2" color="text.secondary">
                    {template.description}
                </Typography>
            )}
            <Box display="flex" gap={1} mt={1}>
                <Chip label={template.code} size="small" />
                <Chip label={formatPrice(template.price)} size="small" color="success" />
                {template.icd10Code && (
                    <Chip label={`ICD-10: ${template.icd10Code}`} size="small" variant="outlined" />
                )}
            </Box>
        </Box>
    )
}
